/**
 * Wrap your scripts within an IIFE or a DOMContentLoaded eventlistener.
 *
 * This will scope our scripts to prevent potential conflicts between
 * our custom work and the main theme stylesheet.
 */

document.addEventListener('DOMContentLoaded', function () {
  // Custom scripts go here...

});

function toggleContent(hiddenElementId, linkElementId) {
    var hiddenContent = document.getElementById(hiddenElementId);
    var toggleLink = document.getElementById(linkElementId);
    
    if (hiddenContent.style.display === "none") {
        hiddenContent.style.display = "inline";
        toggleLink.innerText = "...Read Less";
    } else {
        hiddenContent.style.display = "none";
        toggleLink.innerText = "...Read More";
    }
}

